import {
  TKwikUIInputNumberDecimal,
  TKwikUIInputNumberSize,
  VKwikUIInputNumberDecimal,
  VKwikUIInputNumberSize
} from "./input-number.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isNumber = (x: number) => typeof x === "number";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    decimal: (x: TKwikUIInputNumberDecimal) =>
      VKwikUIInputNumberDecimal.includes(x),
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    isShowLabelOutside: isBoolean,
    label: isString,
    max: isNumber,
    min: isNumber,
    placeholder: isString,
    postfix: isString,
    precision: isNumber,
    prefix: isString,
    size: (x: TKwikUIInputNumberSize) => VKwikUIInputNumberSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
